import { Slider, SliderItem } from "../components/slider";
import { NavSlider, NavSliderItem } from "../components/nav-slider";
import BlogNewsletter from '../components/blog-newsletter';

export default {
	name: 'AboutUs',
	components: {
		Slider,
		SliderItem,
		NavSlider,
		NavSliderItem,
		BlogNewsletter
	},
}
